import { VscGlobe } from "react-icons/vsc";
import { MdContentCopy } from "react-icons/md";
import { MdOpenInNew } from "react-icons/md";
import { Button } from "@/shadcnComponents/ui/button";
import { Download } from "lucide-react";
import { toast } from "react-toastify";
import { useAuth } from "@/Providers/Auth";
import { twMerge } from "tailwind-merge";
import { useStaticData } from "@/Providers/Data";
import React, { useRef } from "react";
import mixpanel from "mixpanel-browser";
import { useNavigate } from "react-router-dom";
import { CiLinkedin } from "react-icons/ci";
import { useGeneralSettings } from "@/Providers/General";
import download from "downloadjs";
import * as htmlToImage from "html-to-image";
import MobileMenuBar from "@/Components/Menubar/MobileMenuBar";
const host: string = import.meta.env.VITE_BACKEND_SERVER_URL;

export const BoostVisibility = () => {
  const staticData = useStaticData();
  const authState = useAuth();
  const navigate = useNavigate();
  const generalState = useGeneralSettings();
  const templateRef = useRef(null);
  const [chipsData, setChipsData] = React.useState({
    referralRate: 0,
  });
  const profile = encodeURI(authState?.loggedUser?.profile);
  React.useEffect(() => {
    if (!authState?.loggedUser?.slug) {
      navigate(`/influencer/dashboard`);
    }
  }, [authState?.loggedUser?.slug]);

  React.useEffect(() => {
    mixpanel.track("Boost Visibility Page visited");
    staticData.getDataFromType("Influencer Chips").then((res: any) => {
      const { referral } = res[0];
      setChipsData({
        ...chipsData,
        referralRate: referral,
      });
    });
  }, []);
  const templateContent = [
    {
      id: 1,
      content: `Know how brand collaborations feel like a guessing game? \nYou aren't sure how to connect with the right people, and they aren't sure what you could offer. \nTo avoid this confusion, I have now taken a step to build my creative portfolio, showcasing my skills and experience. You can check it out here - ${window.location.protocol}//${window.location.host}/${authState?.loggedUser?.slug} \nIt  shows what I'm passionate about, and if it aligns with your brand needs, you can connect with me directly! \nCheck it out and see if we might be a good fit to work together!`,
    },
    {
      id: 2,
      content: `Recently I realised that I spend at least 2 hours each day on my DMs. That's 1 month gone!

            But managing a flood of DMs isn't easy. That too when it's from brands and before finalizing anything, there's a lot of back and forth. Mind you, the collaboration may not even materialise at the end.
            
            Well, I have been there and it not a pleasant experience. Half the time, the fit isn't there, or people ghost you. And let's not even get started on how it feels to justify your worth to brands lowballing offers.
            
            Thankfully, I have found a way to avoid all this!
            
            I've put all my creative skills and experience in one place, so it's like a one-stop shop for anyone looking to explore synergies. You can check it out here: ${window.location.protocol}//${window.location.host}/${authState?.loggedUser?.slug}
            
            This way, we can skip the back-and-forth. You can quickly see what I offer and connect with me directly when there's a genuine fit. Win-Win!`,
    },
    {
      id: 3,
      content: `Landing my first brand collaboration was a total game-changer! It felt like going from zero to hero overnight. 

            I won't sugarcoat it. Finding the right brands and showcasing my skills was a MASSIVE hurdle. 
            
            But if I could go back in time, I'd tell myself: "Get a portfolio together, you!" 
            Seems obvious now, no?
            
            Here's the thing: brands don't have time to scroll through endless profiles hoping to find the right fit. 
            
            Now, thanks to my Collab profile, brands can see everything I've done and what I bring to the table in a few clicks. Here's the link - ${window.location.protocol}//${window.location.host}/${authState?.loggedUser?.slug}
            
            It's like a cheat code for getting noticed! 
            
            No more doom-scrolling for brands, no more waiting on the sidelines for creators. 
            
            Let's skip the guesswork and connect directly if we're a good match! 
            
            Check out my profile and see if we can collaborate on something awesome!`,
    },
    {
      id: 4,
      content: `As creators, we're all about sharing the good stuff, right? The latest knowledge, the hidden gems, the products that truly make a difference.
 
            That's why I'm excited about my personal portfolio I built recently. If you have a product you believe in and want to get the word out, let's chat! My profile showcases my reach, style and expertise, so you can see if it resonates with your brand.
             
            Together, we can bring the best products to light, straight to the people who will love them most.
             
            Connect with me and let's spread the product love together!`,
    },
  ];

  const randomTemplateContent =
    templateContent[Math.floor(Math.random() * templateContent.length)];

  return (
    <>
      <MobileMenuBar />
      <div className="w-full h-max mb-20 md:mb-0 py-5 px-10 font-inter text-[#FFF]">
        <div className="flex flex-col gap-3 mb-[27px]">
          <h1 className="text-[14px] md:text-[24px] font-[700] text-[#FFFFFF]">
            Boost Your Visibility & Land More Collabs!
          </h1>
          <p className="text-[#A3A3A3] text-xs md:text-[16px] font-normal">
            These creative ways will help you stand out and make it easy for
            brands to find you
          </p>
        </div>
        <section className="flex w-full md:w-[945px] flex-col gap-9">
          {/* section 1 */}
          <div className="flex flex-col md:flex-row rounded-[6px] border-[1px] border-[solid] border-[#262626] bg-[rgba(255,_255,_255,_0.02)]">
            <div className="w-full md:w-1/2 p-4 ">
              <div className="flex flex-col gap-[4px]">
                <div className="text-[14px] font-semibold">
                  Showcase On Your Socials
                </div>
                <div className="text-[#A6A6A6] text-[12px] leading-[20px]">
                  Add your public profile link to your LinkedIn, Linktree,
                  Insta, Youtube, etc.
                </div>
              </div>
              <div className="w-fit flex justify-center items-center rounded-[100px] border-[1px] border-[solid] border-[#A3A3A3] mt-5 mb-3">
                <div className="flex px-[8px] py-[6px] justify-start items-center gap-[15px]">
                  <VscGlobe size={18} color="#757575" />
                  <span className="text-[#A3A3A3] text-[12px] font-normal leading-[20px]">
                    {window.location.host}/{authState?.loggedUser?.slug}
                  </span>
                </div>
                <button
                  className="hover:bg-[#232323] hover:rounded-full px-[8px] py-[6px]"
                  onClick={(e) => {
                    e.stopPropagation();
                    mixpanel.track("Copied Profile Link");
                    navigator.clipboard.writeText(
                      `${window.location.protocol}//${window.location.host}/${authState?.loggedUser?.slug}?utm_source=profile`
                    );

                    toast.info("Profile Link Copied", {
                      position: "top-center",
                      autoClose: 1000,
                    });
                  }}
                >
                  <MdContentCopy size={18} color="#757575" />
                </button>
              </div>
              <div className="flex gap-2">
                <LinkButton
                  onClick={() => {
                    mixpanel.track("Clicked on Add in Bio");
                    navigator.clipboard.writeText(
                      `${window.location.protocol}//${window.location.host}/${authState?.loggedUser?.slug}?utm_source=profile`
                    );
                    window.open(
                      "https://www.linkedin.com/in/me/edit/forms/custom-action/new/",
                      "_blank"
                    );
                  }}
                  className="pl-0"
                >
                  <CiLinkedin size={18} />
                  Add in Bio
                  <MdOpenInNew size={14} />
                </LinkButton>
                <LinkButton
                  onClick={() => {
                    mixpanel.track("Clicked on Open Linktree");
                    window.open("https://linktr.ee/", "_blank");
                  }}
                >
                  Open Linktree
                  <MdOpenInNew size={14} />
                </LinkButton>
              </div>
            </div>
            <div className="w-full md:w-1/2 flex  items-center justify-center p-4 ">
              <div className="flex flex-col md:flex-row gap-4">
                <img
                  src={
                    "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/BoostVisibilityNew1.png"
                  }
                  alt=""
                  className="w-[150px] h-[200px] flex-shrink-0 rounded-[10px]"
                />
                <img
                  src={
                    "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/BoostVisibilityNew2.png"
                  }
                  alt=""
                  className="w-[150px] h-[200px] flex-shrink-0 rounded-[10px]"
                />
              </div>
            </div>
          </div>

          {/* section 2 */}
          <div className="flex flex-col md:flex-row rounded-[6px] border-[1px] border-[solid] border-[#262626] bg-[rgba(255,_255,_255,_0.02)]">
            <div className="w-full md:w-2/6 p-4">
              <div className="flex flex-col gap-[4px]">
                <div className="text-[14px] font-semibold">
                  Announce Your Availability
                </div>
                <div className="text-[#A6A6A6] text-[12px] leading-[20px]">
                  Let brands & your network know you're ready to collaborate
                  using our pre-made LinkedIn post templates
                  <div className="pt-5">(You can edit the templates too)</div>
                </div>
              </div>
            </div>
            <div className="w-full md:w-2/6 p-4 flex flex-col gap-6 justify-center items-center">
              <span className="text-[#A6A6A6] text-[12px] font-normal leading-[20px] overflow-hidden overflow-ellipsis">
                {randomTemplateContent?.content.length > 200
                  ? randomTemplateContent?.content.substring(0, 200) + "..."
                  : randomTemplateContent?.content}
              </span>
              <div className="flex items-center">
                <Button
                  className="gap-2 text-[12px] z-10"
                  variant="destructive"
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    mixpanel.track("Copied & Edit Boost Visibility Template");
                    navigator.clipboard.writeText(
                      randomTemplateContent?.content
                    );

                    toast.success("Text Copied", {
                      position: "top-center",
                      autoClose: 1000,
                    });
                  }}
                >
                  <span>Copy & Edit</span>
                  <MdContentCopy size={18} />
                </Button>
                <LinkButton
                  onClick={() => {
                    mixpanel.track("cliked on share on linkedin template");
                    navigator.clipboard.writeText(
                      randomTemplateContent?.content
                    );

                    window.open(
                      `https://www.linkedin.com/shareArticle/?text=${randomTemplateContent?.content}`,
                      "_blank"
                    );
                  }}
                >
                  Share on LinkedIn
                  <MdOpenInNew size={14} />
                </LinkButton>
              </div>
            </div>
            <div className="w-full md:w-2/6 p-4 flex flex-col justify-center items-center">
              <div className="flex flex-col justify-center items-center gap-1">
                <div className=" h-[110px] flex items-center justify-center">
                  <div
                    style={{ transform: "scale(0.25)" }}
                    className="max-w-full max-h-full mb-[100px]"
                  >
                    <div
                      ref={templateRef}
                      className="w-[1000px] h-[500px] bg-[var(--Shade-Black,_#000)] p-8"
                    >
                      <div className="relative rounded-[12px] bg-[rgba(131,_131,_131,_0.12)] backdrop-filter backdrop-blur-[3px] size-full flex-shrink-0">
                        <div className="absolute top-0 rounded-[563px] bg-[#00297A] filter blur-[357px] size-full" />
                        <div className="flex size-full py-10 pl-[46px] pr-[70px]">
                          <div className="z-[4] flex flex-col gap-3 h-full justify-center items-start font-[Inter] not-italic">
                            <span className="text-[20px] font-bold leading-[20px] text-[#FF5C5C]">
                              Hi, 🤝
                            </span>
                            <span className="text-[50px] font-bold leading-[normal] bg-[linear-gradient(121deg,_#B9CDFF_0%,_#FEBFFF_99.87%)] bg-clip-text">
                              Let's connect for collaborations!
                            </span>
                          </div>
                          <div className="flex flex-col justify-center items-center relative overflow-hidden w-[70%] h-full rounded-[20px] border-[1px] border-[#FFFFFF21]/20">
                            <div className="absolute top-0 -left-3 w-[192px] h-[192px] flex-shrink-0 bg-[#94D2FF] filter blur-[122px]" />
                            <div className="z-[4] flex flex-col justify-center items-center gap-[24px]">
                              <img
                                src={
                                  authState?.loggedUser?.profile
                                    ? `${host}/api/file/proxyImage?imageUrl=${profile}`
                                    : ""
                                }
                                alt="influencer"
                                className=" w-[160px] h-[160px] flex-shrink-0 rounded-[160px] bg-[#D9D9D9]"
                              />
                              <div className="space-y-2">
                                <div className="text-[#FFF] text-center font-[Inter] text-[24px] not-italic font-semibold leading-[normal]">
                                  {authState?.loggedUser?.name}
                                </div>
                                <div className="flex justify-center items-center gap-[6px] text-center font-[Inter] text-[18px] not-italic font-semibold leading-[normal]">
                                  <img
                                    src={`${host}/api/file/proxyImage?imageUrl=https://anchors-collab.s3.ap-south-1.amazonaws.com/AudiencePlatform/LinkedIn.svg`}
                                    alt="linkedin"
                                    className="size-[20px] shrink-0"
                                  />
                                  <span className="text-[#BDBDBD] text-center font-[Inter] text-[18px] not-italic font-semibold leading-[normal]">
                                    {authState?.loggedUser?.linkedinfollowers}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="absolute bottom-0 -right-3 w-[192px] h-[192px] flex-shrink-0 bg-[#480090] filter blur-[122px]" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <LinkButton
                  onClick={async () => {
                    mixpanel.track("Downloded Boost Visibilty Graphics Card");
                    if (!authState?.loggedUser?.profile) {
                      return toast.error(
                        "Please Upload your profile Picture to Download Image "
                      );
                    }
                    generalState?.setLoading(true);
                    const dataURL = await htmlToImage.toJpeg(
                      templateRef.current
                    );
                    download(
                      dataURL,
                      `${authState?.loggedUser?.name}_poster.jpeg`,
                      "image/png"
                    );
                    generalState.setLoading(false);
                  }}
                >
                  <Download size={18} />
                  Download Image
                </LinkButton>
              </div>
            </div>
          </div>

          {/* section 3 */}
          <div className="flex flex-col md:flex-row rounded-[6px] border-[1px] border-dashed border-[#262626]">
            <div className="w-full md:w-1/2 p-4 ">
              <div className="flex flex-col gap-[4px]">
                <div className="text-[14px] font-semibold">
                  Refer, Earn & Get 'Featured'
                </div>
                <div className="text-[#A6A6A6] text-[12px] leading-[20px]">
                  Every new creator who joins using your referral link gets you{" "}
                  {chipsData?.referralRate} chips
                </div>
              </div>
              <div className="w-fit flex justify-center items-center rounded-[100px] border-[1px] border-[solid] border-[#A3A3A3] mt-5 mb-3">
                <div className="flex px-[8px] py-[6px] justify-start items-center gap-[15px]">
                  <VscGlobe size={18} color="#757575" />
                  <span className="text-[#A3A3A3] text-[12px] font-normal leading-[20px]">
                    {window.location.host}/influencer/?refer=
                    {authState?.loggedUser?.referralCode}
                  </span>
                </div>
                <button
                  className="hover:bg-[#232323] hover:rounded-full px-[8px] py-[6px]"
                  onClick={(e) => {
                    e.stopPropagation();
                    mixpanel.track("Copied Referral Link");
                    navigator.clipboard.writeText(
                      `${window.location.protocol}//${window.location.host}/influencer/?refer=${authState?.loggedUser?.referralCode}`
                    );

                    toast.info("Refer Link Copied", {
                      position: "top-center",
                      autoClose: 1000,
                    });
                  }}
                >
                  <MdContentCopy size={18} color="#757575" />
                </button>
              </div>
              <div className="flex gap-2">
                <LinkButton
                  onClick={() => {
                    mixpanel.track(
                      "Clicked on share on whatsapp - Referral link"
                    );
                    window.open(
                      `https://api.whatsapp.com/send?text=${`${window.location.protocol}//${window.location.host}/influencer/?refer=${authState?.loggedUser?.referralCode}`}`,
                      "_blank"
                    );
                  }}
                >
                  Share on WhatsApp
                  <MdOpenInNew size={14} />
                </LinkButton>
                <LinkButton
                  onClick={() => {
                    mixpanel.track(
                      "Clicked on share on linkedin - referral link"
                    );
                    navigator.clipboard.writeText(
                      `${window.location.protocol}//${window.location.host}/influencer/?refer=${authState?.loggedUser?.referralCode}`
                    );

                    toast.info("Refer Link Copied", {
                      position: "top-center",
                      autoClose: 1000,
                    });

                    window.open(
                      `https://www.linkedin.com/shareArticle`,
                      "_blank"
                    );
                  }}
                >
                  Share on LinkedIn
                  <MdOpenInNew size={14} />
                </LinkButton>
              </div>
            </div>
            <div className="w-full md:w-1/2 flex items-center justify-center p-4 border-l border-dashed border-[#262626]">
              <div className="flex flex-col justify-center items-center">
                <div className="text-[50px] not-italic font-bold leading-[24px] flex items-center">
                  <img
                    src={
                      "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/f06623be8acc04b336d91541c5dccaec.gif"
                    }
                    alt=""
                    className="size-[60px]"
                  />
                  {generalState?.SidebarChipsCount?.referral ||
                    authState?.loggedUser?.referralCount *
                      chipsData?.referralRate ||
                    0}
                </div>
                <div className="text-[14px] font-[600] leading-[24px]">
                  Chips earned via referral
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export const LinkButton = ({
  children,
  onClick,
  className,
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}) => {
  return (
    <button
      className={twMerge(
        `px-4 py-2 text-[12px] z-10 cursor-pointer font-inter font-medium text-[#DC2627] flex gap-1 items-center hover:underline hover:underline-offset-4`,
        className
      )}
      onClick={() => onClick()}
    >
      {children}
    </button>
  );
};
